import { getProductFormField } from '../utils';
import Component, { ProductFormRadioBooleanProps } from './ProductFormRadioBoolean';
import { injectIntl } from 'react-intl';

export default getProductFormField<ProductFormRadioBooleanProps>(injectIntl(Component));
